import React, { useState } from "react";
import {Card, CardContent, CardMedia, IconButton, Typography, Box, Switch, Popover, Button} from "@mui/material";
import moreicon from "../../assets/landing_page/new/morehorizontal.svg";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import {
  setUserForDelete,
  setUserForEdit,
  setUserForView,
} from "../../Slices/userslice";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import { useNavigate } from "react-router-dom";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
const UserCard = ({ user, getUsers }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleActionOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAction = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-options-popover" : undefined;
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#34C759",
          ...theme.applyStyles("dark", {
            backgroundColor: "#FF2800",
          }),
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgba(0,0,0,.25)",
      boxSizing: "border-box",
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(255,255,255,.35)",
      }),
    },
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleEdit = () => {
    dispatch(
      setUserForEdit({ user_id: user.user_id, isEdit: true, table: false })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };
  const handleDelete = () => {
    dispatch(
      setUserForDelete({ user_id: user.user_id, isDelete: true, table: false })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };
  const handleView = () => {
    dispatch(
      setUserForView({ user_id: user.user_id, isView: true, table: false })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };
  const [userStatus, setUserStatus] = useState(user.user_status);

  return (
    <>
      <Card onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{ borderRadius: 2, width: 200, height: 200 }}>
                <Box
              sx={{
                position: "relative", // To ensure Button is positioned relative to this Box
                width: "100%",
                "&:hover": {
                  color: "#0000001A", // Background color change on hover
                },
              }}>
        <Button
                variant='contained'
                onClick={handleView}
                sx={{
                  display: isHovered ? "block" : "none", // Show on hover
                  position: "absolute",
                  top: "100px", // Center vertically
                  left: "50%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjust position to be exactly in the center
                  backgroundColor: "transparent",
                  color: "#000",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  zIndex: 1,
                  boxShadow: "none",
                  textTransform: "none",
                  border: "1px solid #474747",
                  "&:hover": {
                    backgroundColor: "transparent",
                    border: "1px solid #474747",
                    color: "#000",
                    boxShadow: "none",
                  },
                }}>
                View
              </Button></Box>
              {user.image ? (
          <CardMedia sx={{
            backgroundColor: isHovered ? "#0000001A" : "#E5EEFB66"
          }}
            component='img'
            height='145'
            image={user.image}
            alt={user.name}
          />
        ) : (
          <Box
            sx={{
              height: '145px',
              backgroundColor: isHovered ? "#0000001A" : "#E5EEFB66",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: '48px',
                fontWeight: 500,
                color: '#474747',
                textTransform: 'uppercase',
                fontFamily: "Inter, sans-serif",
              }}
            >
              {user.name ? user.name.charAt(0) : '?'}
            </Typography>
          </Box>
        )}

        <CardContent>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "transparent",
            }}>
              
            <Box>
              <Typography
                variant='h6'
                component='div'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "16.94px",
                  textAlign: "left",
                }}>
                {user.name}
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "10px",
                  fontWeight: 500,
                  lineHeight: "12.1px",
                  textAlign: "left",
                  marginTop: "5px",
                }}>
                Stakeholder
              </Typography>
            </Box>
            <IconButton aria-label='settings' onClick={handleActionOpen}>
              <img
                src={moreicon}
                alt='More options'
                style={{ width: "20px", height: "20px" }}
              />
            </IconButton>
          </Box>
        </CardContent>
      </Card>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseAction}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <Box sx={{ p: 1, width: "130px" }}>
          <Button
            onClick={handleView}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none", // to keep the text lowercase

              color: "black", // you can adjust color as needed
            }}>
            <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='view-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              View
            </Typography>
          </Button>

          <Button
            onClick={handleEdit}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <EditIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='edit-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Edit
            </Typography>
          </Button>

          <Button
            onClick={handleDelete}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='delete-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Delete
            </Typography>
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default UserCard;
